<template>
    <el-dialog title="添加机台" :visible.sync="machineAddDialogVisible" width="50%" @close="machineAddDialogClosed"
        :close-on-click-modal="false">
        <el-form :model="machine" :rules="machineRelues" ref="machineaAddForm" label-width="145px">
            <el-form-item label="机台编号:" prop="machineNumber">
                <el-input v-model="machine.machineNumber"></el-input>
            </el-form-item>
            <el-form-item label="所在车间:" prop="workshop">
                <el-input v-model="machine.workshop"></el-input>
            </el-form-item>
            <el-form-item label="轴长(米):" prop="warpKnittingMachineAxialLength">
                <el-input v-model="machine.warpKnittingMachineAxialLength"></el-input>
            </el-form-item>
            <el-form-item label="面梳(个):" prop="warpKnittingMachineMaxComb">
                <el-input v-model="machine.warpKnittingMachineMaxComb"></el-input>
            </el-form-item>
            <el-form-item label="机台类型:" prop="machineType">
                <el-input v-model="machine.machineType"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="onSubmit()">创建</el-button>
            <el-button @click="cancel()">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/platform/machine/add'
    export default {
        data() {
            var lengthruler = (rules, value, cb) => {
                const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入大于0的正整数'))
            }
            return {
                machineAddDialogVisible: false,
                machine: {
                    factoryId: '', // TODO 工厂ID, 暂时固定为 '维库' factoryId = 234423336573075468
                    machineNumber: '',
                    workshop: '',
                    warpKnittingMachineAxialLength: '',
                    warpKnittingMachineMaxComb: '',
                    machineType: '',
                },
                machineRelues: {
                    machineNumber: [{
                        required: true,
                        message: '请输入机台编号',
                        trigger: 'blur'
                    }],
                    workshop: [{
                        required: true,
                        message: '请输入所属车间',
                        trigger: 'blur'
                    }],
                    warpKnittingMachineAxialLength: [{
                            required: true,
                            message: '请输入轴长',
                            trigger: 'blur'
                        },
                        {
                            validator: lengthruler,
                            trigger: 'blur'
                        }
                    ],
                    warpKnittingMachineMaxComb: [{
                            required: true,
                            message: '请输入面梳',
                            trigger: 'blur'
                        },
                        {
                            validator: lengthruler,
                            trigger: 'blur'
                        }
                    ],
                    machineType: [{
                        required: true,
                        message: '请输入机台类型',
                        trigger: 'blur'
                    }],
                }
            }
        },
        methods: {
            // 外部调用，显示添加机台弹框
            show(factoryId) {
                this.machineAddDialogVisible = true

                // console.log('factoryId=', factoryId)
                this.machine.factoryId = factoryId // 更新工厂id
            },
            // 监听回车按钮
            keyCodeListen() {
                // const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode
                const code = event.keyCode
                if (code === 13) this.onSubmit()
            },
            // 点击创建按钮
            onSubmit() {
                this.$refs.machineaAddForm.validate(valid => {
                    if (!valid) return
                    const data = this.machine
                    api.onSubmit(data).then(res => {
                        this.$Message.success('机台创建成功！')
                        this.$refs.machineaAddForm.resetFields()
                        this.machineAddDialogVisible = false
                        // TODO 隐藏性的问题 如果当前页达到size上限，再去创应该是去请求一下页了
                        this.$emit('update')
                    })
                })
            },
            // 点击取消按钮触发
            cancel() {
                this.machineAddDialogVisible = false
            },
            mounted() {
                document.addEventListener('keyup', this.keyCodeListen)
            },
            destroyed() {
                document.removeEventListener('keyup', this.keyCodeListen)
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
